import React from 'react'

class AovDisplay extends React.Component {
  displayText = aovs => {
    switch (aovs.length) {
      case 0:
        return 'Variable'
      case 1:
        return aovs[0].range_text
    }
  }

  render() {
    return (
      <tr>
        <td style={{ verticalAlign: 'top' }}>
          AoV
        </td>
        <td>
          {this.displayText(this.props.aovs)}
        </td>
      </tr>
    )
  }
}

export default AovDisplay



// WEBPACK FOOTER //
// ./src/components/CameraModelSelector/CameraDetailsContainer/CameraDetails/AovDisplay/index.js